module.exports = __webpack_public_path__ + "img/player-button.58f5b357.svg";